import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";

import LanguageSwitcher from "../components/LanguageSwitcher";

export default function EmailVerified() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { token } = useParams();

  const [status, setStatus] = useState("loading"); // loading | success | error
  const [errorMessage, setErrorMessage] = useState("");

  // Get temp user info if needed
  const tempUser = JSON.parse(localStorage.getItem("tempUser")) || {};
  const name = tempUser.firstName || "User";

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/verify-email/${token}`, {
          headers: { lang: i18n.language },
        });
        setStatus("success");
      } catch (err) {
        console.error("Email verification failed:", err);
        setStatus("error");
        setErrorMessage(err.response?.data?.message || t("verificationFailed"));
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, i18n.language, t]);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-6 text-gray-800"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <div className="absolute top-6 ltr:right-6 rtl:left-6">{/* <LanguageSwitcher /> */}</div>

      {/* Content depending on status */}
      {status === "loading" && (
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-purple-500 border-t-transparent"></div>
          <p className="text-gray-600">{t("verifyingEmail")}...</p>
        </div>
      )}

      {status === "success" && (
        <div className="flex flex-col items-center gap-4">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100 text-green-600 shadow-md">
            <FaCheckCircle size={40} />
          </div>
          <h1 className="text-center text-2xl font-bold text-gray-900 sm:text-3xl">{t("emailVerified")}</h1>
          <p className="max-w-sm text-center text-gray-600">{t("verifiedMessage", { name })}</p>
        </div>
      )}

      {status === "error" && (
        <div className="flex flex-col items-center gap-4">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100 text-red-600 shadow-md">
            <FaTimesCircle size={40} />
          </div>
          <h1 className="text-center text-2xl font-bold text-red-600 sm:text-3xl">
            {t("verificationFailed")}
          </h1>
          <p className="max-w-sm text-center text-gray-600">{errorMessage}</p>
        </div>
      )}

      {/* Actions */}
      {status !== "loading" && (
        <div className="mt-8 flex flex-col items-center gap-4 text-center">
          <button
            onClick={() => navigate("/auth/login")}
            className="w-full max-w-xs rounded-lg bg-purple-500 px-6 py-3 font-semibold text-white shadow transition hover:bg-purple-600"
          >
            {t("goToLogin")}
          </button>
        </div>
      )}
    </div>
  );
}
